import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { MakeupBooking } from '~entities/makeup/api/book-makeup';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export type MakeupStatusUpdate = 'completed' | 'no_show' | 'cancelled';

export const updateMakeupStatusAPI = async (params: {
  makeupId: string;
  status: MakeupStatusUpdate;
}) => {
  const response = await baseAPI.patch<MakeupBooking>(
    `/makeup/${params.makeupId}/status`,
    { status: params.status },
  );
  return response.data;
};

export const useUpdateMakeupStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMakeupStatusAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.MAKEUP_BALANCES] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_CLASS_DATE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_SOURCE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_TARGETS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_STUDENT],
      });
    },
  });
};
